import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Badge, Button } from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { LanguageProvider } from '../../core/language-provider';
import IC_Question from '../components/IC_Question';
import IC_referralCode from '../components/referral_code/IC_referralCode';



export default function InstanceCompilerTopHook({ data, dataId, entity = null, setDataKeyValue }) {

    useEffect(() => {
        
    }, []);



    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch(entity) {
                        case 'sample': return (
                            <span>Test</span>
                        );
                        case 'question': return (
                            <IC_Question data={data} dataId={dataId} setDataKeyValue={setDataKeyValue} />
                        );
                        case 'referral_code': return (
                            <IC_referralCode data={data} dataId={dataId} setDataKeyValue={setDataKeyValue} />
                        );
                        default: return (
                            <></>
                        );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};